/* eslint-disable */
<template>
  <div>
    <meta name="referrer" content="never" >
    <div v-show="show">
      <div class="header"><img style="width: 150px; " src="../../../static/logo.png" class="logo" alt="" ></div>
      <van-tabs v-model="activeName" type="card" sticky>
        <van-tab title="个人登录" name="a">
          <div class="hr">
            <van-cell-group style="margin:10px 0px;">
              <van-field v-model="loginPrForm.mobile" style="border: #EEEEEE solid 1px;margin-bottom: 20px;" label="手机号" left-icon="user-o" placeholder="请输入手机号" />
              <van-field
                v-model="loginPrForm.Prpassword"
                style="border: #EEEEEE solid 1px;"
                label="密码"
                input-align="left"
                left-icon="lock"
                type="password"
                placeholder="请输入密码"
              />
            </van-cell-group>
            <van-row class="item">
              <van-col span="8" />
              <van-col span="7" />
              <van-col span="9" style="font-size: 12px;"><van-checkbox v-model="loginPrForm.remember" shape="square">记住手机号和密码</van-checkbox></van-col>
            </van-row>
            <van-button type="danger" size="large" @click="login1">登录</van-button>
            <van-row style="font-size: 0.75rem;">
              <van-col span="3">
                <van-button style="margin-top: 10px; font-size: 13px;color: #07c160;border: 0px;" type="default" size="large" to="/hr/register" @click="ifshow">注册</van-button>
              </van-col>
              <van-col span="5">
                <van-button style="margin-top: 10px;font-size: 13px;border: 0px ;color: #1989fa;" type="default" size="large" to="/hr/home/up" @click="ifshow">重置密码</van-button>
              </van-col>
            </van-row>
          </div>
        </van-tab>
        <van-tab title="企业用户登录" name="b">
          <div class="hr">
            <van-cell-group style="margin:10px 0px;">
              <van-field v-model="loginForm.account" style="border: #EEEEEE solid 1px;margin-bottom: 20px;" label="用户名" left-icon="user-o" placeholder="请输入企业全称" />
              <van-field
                v-model="loginForm.password"
                style="border: #EEEEEE solid 1px;"
                label="密码"
                input-align="left"
                left-icon="lock"
                type="password"
                placeholder="请输入密码"
              />
            </van-cell-group>
            <van-row class="item">
              <van-col span="8" />
              <van-col span="7" />
              <van-col span="9" style="font-size: 12px;"><van-checkbox v-model="loginForm.remember" shape="square">记住用户名和密码</van-checkbox></van-col>
            </van-row>

            <van-button type="danger" size="large" @click="login2">登录</van-button>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <div><router-view /></div>
    <!-- <van-tabbar v-model="active">
      <van-tabbar-item badge="3">
        <span>自定义</span>
        <template #icon="props">
          <img :src="props.active ? icon.active : icon.inactive" >
        </template>
      </van-tabbar-item>
      <van-tabbar-item icon="search">标签</van-tabbar-item>
      <van-tabbar-item icon="setting-o">标签</van-tabbar-item>
    </van-tabbar> -->
  </div>
</template>

<script>
import Vue from 'vue';
import { Dialog } from 'vant';

import { Notify } from 'vant';
const Base64 = require('js-base64').Base64;
Vue.use(Notify);
Vue.use(Dialog);
export default {
  name: 'Hrhome',
  inject: ['reload'],
  data() {
    return {
      loginForm: {
        account: '',
        password: '',
        remember: true
      },
      loginPrForm: {
        mobile: '',
        Prpassword: '',
        remember: true
      },
      Prpassword: 'aa',
      activeName: 'a',
      value1: '',
      Mn: [],
      children: [],
      value2: '',
      sw: true,
      show: sessionStorage.getItem('show'),
      active: 0,
      icon: {
        active: 'https://img.yzcdn.cn/vant/user-active.png',
        inactive: 'https://img.yzcdn.cn/vant/user-inactive.png'
      }
    };
  },
  beforeCreate() {
    sessionStorage.setItem('show', true);
    if (sessionStorage.getItem('show')) {
      this.show = true;
    }
  },
  created() {
    sessionStorage.setItem('show', true);

    const accountx = this.getLocalStorage('account');
    const passwordx = Base64.decode(this.getLocalStorage('passWord'));
    // 如果存在赋值给表单，并且将记住密码勾选
    if (accountx) {
      this.loginForm.account = accountx;
      this.loginForm.password = passwordx;
      this.loginForm.remember = true;
    }

    // // 在页面加载时从cookie获取登录信息
    const mobile = this.getLocalStorage('mobile');

    const Prpassword = Base64.decode(this.getLocalStorage('Prpassword'));

    // 如果存在赋值给表单，并且将记住密码勾选
    if (mobile) {
      this.loginPrForm.mobile = mobile;
      this.loginPrForm.Prpassword = Prpassword;
      this.loginPrForm.remember = true;
    }
  },
  mounted() {
    sessionStorage.setItem('show', true);
  },
  updated() {
    this.show = sessionStorage.getItem('show');
  },
  methods: {
    login1() {
      const url = 'staff';
      const qc = { cx_user: 'chunxue', phone: this.loginPrForm.mobile, password: this.loginPrForm.Prpassword };
      this.queryLogin('/customer/staff/login', qc);
    },
    login2() {
      const url = 'user';
      const qc = { cx_user: 'chunxue', username: this.loginForm.account, password: this.loginForm.password, menu_type: 4 };
      this.queryLogin('/customer/user/wxhr-login', qc);
    },
    queryLogin(url, qc) {
      this.axios.post(url, qc).then(res => {
        if (res.data.success) {
          const mxi = res.data.obj.Mn;
          const Mn = res.data.obj.Mn.length;
          if (Mn !== 0) {
            for (var i = 0; i < Mn; i++) {
              if (mxi[i].children != null) {
                for (let a = 0; a < mxi[i].children.length; a++) {
                  this.children.push({ id: mxi[i].children[a].id, pid: mxi[i].children[a].pid, name: mxi[i].children[a].name, url: mxi[i].children[a].url });
                }
              }
              this.Mn.push({ id: mxi[i].id, name: mxi[i].name, children: mxi[i].children });
            }
            if (res.data.empId !== '') {
              sessionStorage.setItem('emp_id', res.data.empId);
            } else {
              sessionStorage.setItem('emp_id', null);
            }
            sessionStorage.setItem('id_card', res.data.idcard);
            sessionStorage.setItem('username', res.data.obj.Us.username);
            sessionStorage.setItem('token', res.data.token);
            sessionStorage.setItem('who', res.data.who);
            sessionStorage.setItem('popup_time', 0); // 登录弹出提示判断条件
            if (res.data.who === 0) {
              sessionStorage.setItem('create_id', 9999999);
              sessionStorage.setItem('client_id', res.data.obj.Us.client_ids);
            } else {
              sessionStorage.setItem('create_id', 666);
            }
            this.$router.push({
              name: 'Index',
              params: {
                menu: this.Mn,
                children: this.children
              }
            });
            sessionStorage.setItem('menu', JSON.stringify(this.Mn));
            sessionStorage.setItem('children', JSON.stringify(this.children));
            this.sys();
            this.query();
          }
        } else {
          Notify({ type: 'danger', message: res.data.msg });
        }
      });
      this.setUserInfo();
    },
    // 储存表单信息
    setUserInfo: function() {
      // 判断用户是否勾选记住密码，如果勾选，向cookie中储存登录信息，
      // 如果没有勾选，储存的信息为空
      if (this.loginForm.remember) {
        this.setLocalStorage('account', this.loginForm.account);
        this.setLocalStorage('passWord', Base64.encode(this.loginForm.password));
      } else {
        this.setLocalStorage('account', '');
        this.setLocalStorage('passWord', '');
      }

      if (this.loginPrForm.remember) {
        this.setLocalStorage('mobile', this.loginPrForm.mobile);
        this.setLocalStorage('Prpassword', Base64.encode(this.loginPrForm.Prpassword));
      } else {
        this.setLocalStorage('mobile', '');
        this.setLocalStorage('Prpassword', '');
      }
    },

    sys() {
      this.axios
        .post('/sys-dictionaries/list', {
          token: sessionStorage.getItem('token'),
          rows: 2000
        })
        .then(res => {});
    },
    query() {
      if (sessionStorage.getItem('id_card') !== 'undefined') {
        this.axios
          .post('/client-employee/wx-list', {
            token: sessionStorage.getItem('token'),
            id_card: sessionStorage.getItem('id_card'),
            id: parseInt(sessionStorage.getItem('emp_id')),
            rows: 2000
          })
          .then(res => {
            if (res.data.rows !== null) {
              sessionStorage.setItem('name', res.data.rows[0].name);
              sessionStorage.setItem('phone', res.data.rows[0].phone);
              sessionStorage.setItem('client_id', res.data.rows[0].client_id);
              sessionStorage.setItem('hold_nature', res.data.rows[0].hold_nature);
            }
          });
      }
    },
    ifshow() {
      this.show = false;
    },
    setLocalStorage(key, value) {
      var curtime = new Date().getTime(); // 获取当前时间 ，转换成JSON字符串序列
      var valueDate = JSON.stringify({
        val: value,
        timer: curtime
      });
      try {
        localStorage.setItem(key, valueDate);
      } catch (e) {
        /* if(e.name === 'QUOTA_EXCEEDED_ERR' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
                console.log("Error: 本地存储超过限制");
                localStorage.clear();
            } else {
                console.log("Error: 保存到本地存储失败");
            }*/
        // 兼容性写法
        if (this.isQuotaExceeded(e)) {
          console.log('Error: 本地存储超过限制');
          localStorage.clear();
        } else {
          console.log('Error: 保存到本地存储失败');
        }
      }
    },
    isQuotaExceeded(e) {
      var quotaExceeded = false;
      if (e) {
        if (e.code) {
          switch (e.code) {
            case 22:
              quotaExceeded = true;
              break;
            case 1014: // Firefox
              if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
                quotaExceeded = true;
              }
              break;
          }
        } else if (e.number === -2147024882) {
          // IE8
          quotaExceeded = true;
        }
      }
      return quotaExceeded;
    },

    getLocalStorage(key) {
      var exp = 60 * 60 * 500; // 一天的秒数
      if (localStorage.getItem(key)) {
        var vals = localStorage.getItem(key); // 获取本地存储的值
        var dataObj = JSON.parse(vals); // 将字符串转换成JSON对象
        // 如果(当前时间 - 存储的元素在创建时候设置的时间) > 过期时间
        var isTimed = new Date().getTime() - dataObj.timer > exp;
        if (isTimed) {
          console.log('存储已过期');
          localStorage.removeItem(key);
          return null;
        } else {
          var newValue = dataObj.val;
        }
        return newValue;
      } else {
        return null;
      }
    }
  }
};
</script>

<style scoped>
.van-cell >>> .van-field__label {
  width: 50px;
  line-height: 20px;
}
.header {
  margin-bottom: 10px;
  padding-top: 0.22em;
  background: linear-gradient(91deg, #f1eefc, #9dc6ff 70%, #a5bcff); /* （body背景色） */
  text-align: center;
}
.hr {
  margin: 0 auto;
  padding: 20px;
  width: 90%;
}
.item {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/hr/home.vue